import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMTableHighlightCell, IMTableScrollToCell } from './typings';

@Injectable()
export class MTableService {
  /**
   * 不建议在外部直接调用，请使用 scrollToCell 方法
   */
  scroll$ = new BehaviorSubject<IMTableScrollToCell | null>(null);
  /**
   * 不建议在外部直接调用，请使用 highLightCells 方法
   */
  highlightCells$ = new BehaviorSubject<IMTableHighlightCell[]>([]);

  scrollToCell(params: IMTableScrollToCell): void {
    this.scroll$.next(params);
  }

  highlightCells(params: IMTableHighlightCell[]): void {
    this.highlightCells$.next(params);
  }
}
